import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SettingNav(props){
    const { t } = useTranslation();
    return (
        <>
        <ul className="settings-pg-links list-unstyled">
                        <li><Link to={`/dashboard/settings`} className={`${props.active_menu=='profile'?'active':''}`}>
                            <i className="fa-light fa-edit" />{t('settingNav.edit_profile')}</Link>
                        </li>
                        <li><Link to={`/dashboard/settings/languages`} className={`${props.active_menu=='languages'?'active':''}`}><i class="fa-solid fa-globe" />{t('settingNav.languages')}</Link></li>
                        <li><Link to={`/dashboard/settings/schedules`} className={`${props.active_menu=='schedules'?'active':''}`}><i class="fa-regular fa-calendar-days" />{t('settingNav.schedules')}</Link></li>
                        <li><Link to={`/dashboard/settings/change-password`} className={`${(props.active_menu=='password' || props.active_menu=='change-password')?'active':''}`}><i className="fa-light fa-lock" />{t('settingNav.change_password')}</Link></li>
                        <li><Link to={`/dashboard/settings/change-bank-info`} className={`${props.active_menu=='bank'?'active':''}`}><i className="fa-light fa-bank" />{t('settingNav.bank_account')}</Link></li>
                                            </ul>
        </>
    )
}